import React from 'react'
import styled from 'styled-components'
import { STYLES } from '../../static/style'

export const TopNavLinkListItem = styled.div`
  font-weight: ${STYLES.FONT_WEIGHT_BOLD};
  display: flex;
  align-items: center;
  height: 100%;
`
